if (!customElements.get("gorgias-chat-button")) {
	customElements.define(
		"gorgias-chat-button",
		class extends HTMLElement {
			/** @type {HTMLButtonElement} */
			button;

			connectedCallback() {
				this.button = this.querySelector("button");
				if (this.button) {
					this.button.disabled = true;
					this.button.addEventListener("click", this);
					if (globalThis.GorgiasChat) {
						this.init();
					} else {
						globalThis.addEventListener("gorgias-widget-loaded", () => this.init());
					}
				}
			}

			disconnectedCallback() {
				this.button.removeEventListener("click", this);
			}

			init() {
				this.button.disabled = false;
				this.hidden = false;
				this.button.hidden = false;
			}

			handleEvent(event) {
				if (event.type === "click") {
					globalThis.GorgiasChat?.open?.();
				}
			}
		},
	);
}
